export default {"src":"/_next/static/media/light-challenge.1cfa400d.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};